var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZapplication(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.35 0 14.69 0 22.1 0 C22.1 1.7 22.1 3.4 22.1 5.14 C20.57 6.95 18.82 8.25 16.65 9.75 C16.13 10.14 15.62 10.53 14.97 10.91 C13.88 11.62 12.77 12.31 11.05 13.6 C15.21 13.9 19.37 14.2 22.1 14.5 C22.1 16.2 22.1 17.9 22.1 19.65 C14.77 19.65 7.43 19.65 0 19.65 C0 17.9 0 16.2 0 14.5 C1.85 12.95 3.44 11.6 5.55 9.9 C6.06 9.5 6.57 9.1 7.14 8.72 C8.23 7.96 9.38 7.21 11.05 6 C7.65 5.7 4.24 5.4 0 5.14 C0 3.4 0 1.7 0 0 Z ",
    fill: "#87C140",
    transform: "translate(2.6,4.25)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 5.98 0 C6.27 2.34 6.27 2.34 5.98 5.1 C3.93 7.12 3.93 7.12 1.7 8.5 C1.15 8.5 0.58 8.5 0 8.5 C0 5.72 0 2.94 0 0 Z ",
    fill: "#1B8747",
    transform: "translate(18.7,4.25)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.25 0 4.5 0 6.82 0 C6.82 1.7 6.82 3.4 6.82 5.1 C4.5 5.1 2.18 5.1 0 5.1 C0 3.4 0 1.7 0 0 Z ",
    fill: "#3A9C5C",
    transform: "translate(17.9,18.7)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.69 0 3.38 0 5.1 0 C5.1 1.12 5.1 2.24 5.1 3.4 C3.4 3.4 1.7 3.4 0 3.4 C0 2.26 0 1.13 0 0 Z ",
    fill: "#107F40",
    transform: "translate(18.7,19.6)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapplication);
export default __webpack_public_path__ + "static/media/zapplication.2249c6b8da092be6542bbcd1ed98ae30.svg";
export { ForwardRef as ReactComponent };